import { XIcon } from "lucide-react";
import { useId } from "react";
import { useTranslations } from "../../i18n";
import { clsx } from "clsx";
import { IconButton } from "../Button/IconButton";
import { Typography } from "../Typography";
import { useModalContext } from "./context";

export const ModalContent = () => {
  const {
    title,
    description,
    footer,
    children,
    handleDismiss,
    showClose,
    open,
    className,
    preventClose,
    floatingContext,
    getFloatingProps,
    handleAnimationEnd,
    mounted,
    visible,
    accessory,
  } = useModalContext();

  const { t } = useTranslations();
  const titleId = useId();
  const descriptionId = useId();

  const containerClasses = clsx(
    "nuco-modal__container",
    visible && mounted
      ? "nuco-modal__container--visible"
      : "nuco-modal__container--hidden",
    className,
  );

  return (
    <div className="nuco-modal__wrapper">
      <div
        ref={floatingContext.refs.setFloating}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? titleId : undefined}
        aria-describedby={description ? descriptionId : undefined}
        data-state={open ? "open" : "closed"}
        className={containerClasses}
        onTransitionEnd={handleAnimationEnd}
        tabIndex={-1}
        {...getFloatingProps()}
      >
        {(title || description) && (
          <header data-modal-header className="nuco-modal__header">
            <div className="nuco-modal__header-content">
              {title && (
                <Typography
                  id={titleId}
                  as="h3"
                  variant="h3"
                  weight="bold"
                  className="nuco-modal__title"
                  text={title}
                />
              )}
              {description && (
                <Typography
                  id={descriptionId}
                  as="div"
                  variant="headline"
                  className="nuco-modal__description"
                  text={description}
                />
              )}
            </div>
            <div className="nuco-modal__buttons">
              {accessory}
              {showClose !== false && !preventClose && (
                <IconButton
                  variant="ghost"
                  color="layer1"
                  size="md"
                  onClick={handleDismiss}
                  aria-label={t("ui.modal.closeLabel")}
                >
                  <XIcon />
                </IconButton>
              )}
            </div>
          </header>
        )}
        <div data-modal-body className="nuco-modal__body">
          {children}
        </div>
        {footer && (
          <footer data-modal-footer className="nuco-modal__footer">
            {footer}
          </footer>
        )}
      </div>
    </div>
  );
};
